import * as api from '../../../../../api/masters/users/permission/permissionApi';
import {
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE,
  ADD_PERMISSION_SUCCESS,
  UPDATE_PERMISSION_SUCCESS,
  DELETE_PERMISSION_SUCCESS,
  SET_EDITING_PERMISSION,
  CLEAR_EDITING_PERMISSION
} from '../../../../types/masters/users/permission/permissionTypes';

export const fetchPermissions = () => async (dispatch) => {
  dispatch({ type: FETCH_PERMISSIONS_REQUEST });
  try {
    const permissions = await api.fetchPermissions();
    dispatch({ type: FETCH_PERMISSIONS_SUCCESS, payload: permissions });
  } catch (error) {
    dispatch({ type: FETCH_PERMISSIONS_FAILURE, error: error.message });
  }
};

export const addPermission = (permission) => async (dispatch) => {
  const newPermission = await api.addPermission(permission);
  dispatch({ type: ADD_PERMISSION_SUCCESS, payload: newPermission });
};

export const updatePermission = ({ id, permission }) => async (dispatch) => {
  const updated = await api.updatePermission(id, permission);
  dispatch({ type: UPDATE_PERMISSION_SUCCESS, payload: updated });
};

export const deletePermission = (id) => async (dispatch) => {
  await api.deletePermission(id);
  dispatch({ type: DELETE_PERMISSION_SUCCESS, payload: id });
};

export const setEditingPermission = (permission) => ({ type: SET_EDITING_PERMISSION, payload: permission });
export const clearEditingPermission = () => ({ type: CLEAR_EDITING_PERMISSION });
